import React from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "./AuthContext";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";
import InstallPWA from "../components/InstallPWA";
import { theme } from "../styles/theme";
import hero from "../assets/images/triangulo.avif";

function Home() {
  const { currentUser } = useAuthContext();

  const features = [
    {
      icon: "🚗",
      title: "Acesso 24/7",
      description: "Pratique onde e quando quiser, no computador ou celular.",
      color: theme.colors.primary,
    },
    {
      icon: "📚",
      title: "Conteúdo Atualizado",
      description: "Perguntas baseadas nos exames mais recentes de trânsito.",
      color: theme.colors.secondary,
    },
    {
      icon: "⚡",
      title: "Feedback Imediato",
      description: "Descubra onde você está errando e melhore seu desempenho.",
      color: theme.colors.info,
    },
    {
      icon: "💰",
      title: "Preço Acessível",
      description: "Tenha acesso ao melhor conteúdo pelo preço mais acessível do país.",
      color: theme.colors.warning,
    },
  ];

  // Separar os features
  const topFeatures = features.slice(0, 3);
  const bottomFeature = features[3];

  const stats = [
    { number: "350+", label: "Perguntas" },
    { number: "95%", label: "Taxa de Aprovação" },
    { number: "24/7", label: "Disponível" },
    { number: "400+", label: "Usuários" },
  ];

  return (
    <div style={{ fontFamily: theme.typography.fontFamily.primary }}>
      <InstallPWA />
      {/* Hero Section */}
      <section
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `linear-gradient(135deg, rgba(230, 0, 0, 0.3), rgba(0, 0, 0, 0.8)), url(${hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          color: theme.colors.white,
          padding: theme.spacing.xl,
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "800px", zIndex: 2 }}>
          <h1 
            style={{ 
              fontSize: window.innerWidth < 768 ? theme.typography.fontSize['3xl'] : theme.typography.fontSize['5xl'],
              fontWeight: theme.typography.fontWeight.bold,
              marginBottom: theme.spacing.lg,
              textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
            }}
          >
            Teste de Condução
          </h1>
          <p 
          style={{
              fontSize: window.innerWidth < 768 ? theme.typography.fontSize.lg : theme.typography.fontSize.xl,
              marginBottom: theme.spacing['2xl'],
              opacity: 0.9,
              lineHeight: 1.6,
              padding: window.innerWidth < 768 ? `0 ${theme.spacing.md}` : 0,
            }}
          >
            Pratique e prepare-se para seu exame teórico de maneira simples e eficiente!
          </p>
          
          <div style={{ 
            display: "flex", 
            gap: window.innerWidth < 768 ? theme.spacing.md : theme.spacing.lg, 
            justifyContent: "center",
            flexWrap: "wrap",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
            alignItems: window.innerWidth < 768 ? "stretch" : "center",
          }}>
            <Button 
              size="lg" 
              variant="primary"
              onClick={() => window.location.href = currentUser ? "/selectquiz" : "/login"}
            >
              {currentUser ? "Começar Teste" : "Entrar"}
            </Button>
            
            <Button 
              size="lg" 
              variant="outline"
              onClick={() => window.location.href = "/quiz/1"}
            >
              Teste Gratuito
            </Button>
          </div>
        </div>

        {/* Scroll indicator */}
        <div style={{
          position: "absolute",
          bottom: theme.spacing.xl,
          left: "50%",
          transform: "translateX(-50%)",
          animation: "bounce 2s infinite",
        }}>
          <div style={{
            width: "30px",
            height: "50px",
            border: `2px solid ${theme.colors.white}`,
            borderRadius: "15px",
            display: "flex",
            justifyContent: "center",
            paddingTop: "8px",
          }}>
            <div style={{
              width: "4px",
              height: "8px",
              backgroundColor: theme.colors.white,
              borderRadius: "2px",
              animation: "scroll 2s infinite",
            }} />
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{
        padding: `${theme.spacing['3xl']} ${theme.spacing.xl}`,
        backgroundColor: theme.colors.gray[50],
      }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: window.innerWidth < 768 ? "repeat(auto-fit, minmax(150px, 1fr))" : "repeat(auto-fit, minmax(200px, 1fr))",
          gap: window.innerWidth < 768 ? theme.spacing.lg : theme.spacing.xl,
        }}>
          {stats.map((stat, index) => (
            <Card key={index} variant="elevated" style={{ textAlign: "center" }}>
              <div style={{
                fontSize: theme.typography.fontSize['4xl'],
                fontWeight: theme.typography.fontWeight.bold,
                color: theme.colors.primary,
                marginBottom: theme.spacing.sm,
              }}>
                {stat.number}
              </div>
              <div style={{
                fontSize: theme.typography.fontSize.lg,
                color: theme.colors.gray[600],
                fontWeight: theme.typography.fontWeight.medium,
              }}>
                {stat.label}
              </div>
            </Card>
          ))}
    </div>
      </section>

      {/* Features Section */}
      <section style={{
        padding: `${theme.spacing['3xl']} ${theme.spacing.xl}`,
        backgroundColor: theme.colors.white,
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: theme.spacing['3xl'] }}>
            <h2 style={{
              fontSize: window.innerWidth < 768 ? theme.typography.fontSize['2xl'] : theme.typography.fontSize['4xl'],
              fontWeight: theme.typography.fontWeight.bold,
              color: theme.colors.gray[800],
              marginBottom: theme.spacing.lg,
            }}>
              Por que Usar o Nosso App?
            </h2>
            <p style={{
              fontSize: theme.typography.fontSize.xl,
              color: theme.colors.gray[600],
              maxWidth: "600px",
              margin: "0 auto",
            }}>
              Descubra como nossa plataforma pode ajudar você a passar no exame de condução
            </p>
    </div>

          <div style={{
            display: "grid",
            gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "repeat(3, 1fr)",
            gap: window.innerWidth < 768 ? theme.spacing.lg : theme.spacing.xl,
            justifyItems: "center",
          }}>
            {topFeatures.map((feature, index) => (
              <Card key={index} variant="default" hover>
                <div style={{
                  fontSize: "3rem",
                  marginBottom: theme.spacing.lg,
                  textAlign: "center",
                }}>
                  {feature.icon}
                </div>
                <h3 style={{
                  fontSize: theme.typography.fontSize.xl,
                  fontWeight: theme.typography.fontWeight.bold,
                  color: feature.color,
                  marginBottom: theme.spacing.md,
                  textAlign: "center",
                }}>
                  {feature.title}
                </h3>
                <p style={{
                  fontSize: theme.typography.fontSize.base,
                  color: theme.colors.gray[600],
                  lineHeight: 1.6,
                  textAlign: "center",
                }}>
                  {feature.description}
                </p>
              </Card>
            ))}
          </div>
          {/* Preço Acessível centralizado embaixo */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            marginTop: window.innerWidth < 768 ? theme.spacing.lg : theme.spacing['2xl'],
          }}>
            <div style={{ maxWidth: 350, width: "100%" }}>
              <Card variant="default" hover>
                <div style={{
                  fontSize: "3rem",
                  marginBottom: theme.spacing.lg,
                  textAlign: "center",
                }}>
                  {bottomFeature.icon}
                </div>
                <h3 style={{
                  fontSize: theme.typography.fontSize.xl,
                  fontWeight: theme.typography.fontWeight.bold,
                  color: bottomFeature.color,
                  marginBottom: theme.spacing.md,
                  textAlign: "center",
                }}>
                  {bottomFeature.title}
                </h3>
                <p style={{
                  fontSize: theme.typography.fontSize.base,
                  color: theme.colors.gray[600],
                  lineHeight: 1.6,
                  textAlign: "center",
                }}>
                  {bottomFeature.description}
                </p>
              </Card>
            </div>
          </div>
    </div>
</section>

      {/* CTA Section */}
      <section style={{
        padding: `${theme.spacing['3xl']} ${theme.spacing.xl}`,
        backgroundColor: theme.colors.primary,
        color: theme.colors.white,
          textAlign: "center",
      }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{
            fontSize: theme.typography.fontSize['4xl'],
            fontWeight: theme.typography.fontWeight.bold,
            marginBottom: theme.spacing.lg,
          }}>
            Pronto para começar?
          </h2>
          <p style={{
            fontSize: theme.typography.fontSize.xl,
            marginBottom: theme.spacing['2xl'],
            opacity: 0.9,
          }}>
            Junte-se a centenas de pessoas que já passaram no exame usando nossa plataforma
          </p>
          <Button 
            size="lg" 
            variant="secondary"
            onClick={() => window.location.href = currentUser ? "/selectquiz" : "/register"}
          >
            {currentUser ? "Fazer Teste Agora" : "Criar Conta"}
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        backgroundColor: theme.colors.gray[800],
        color: theme.colors.white,
        padding: theme.spacing.xl,
        textAlign: "center",
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: theme.spacing.xl,
            marginBottom: theme.spacing.xl,
          }}>
            <div>
              <h3 style={{
                fontSize: theme.typography.fontSize.xl,
                fontWeight: theme.typography.fontWeight.bold,
                marginBottom: theme.spacing.md,
              }}>
                <a 
                  style={{ color: theme.colors.primary, textDecoration: "none" }}
                >
                  Draiva
                </a>
              </h3>
              <p style={{ color: theme.colors.gray[400] }}>
                A melhor plataforma de testes de condução em Moçambique
              </p>
            </div>
            <div>
              <h4 style={{
                fontSize: theme.typography.fontSize.lg,
                fontWeight: theme.typography.fontWeight.semibold,
                marginBottom: theme.spacing.md,
              }}>
                Links Úteis
              </h4>
              <div style={{ display: "flex", flexDirection: "column", gap: theme.spacing.sm }}>
                <Link to="/" style={{ color: theme.colors.gray[400], textDecoration: "none" }}>
                  Início
                </Link>
                <Link to="/selectquiz" style={{ color: theme.colors.gray[400], textDecoration: "none" }}>
                  Testes
                </Link>
                <Link to="/results" style={{ color: theme.colors.gray[400], textDecoration: "none" }}>
                  Resultados
                </Link>
              </div>
            </div>
            <div>
              <h4 style={{
                fontSize: theme.typography.fontSize.lg,
                fontWeight: theme.typography.fontWeight.semibold,
                marginBottom: theme.spacing.md,
              }}>
                Suporte
              </h4>
              <p style={{ color: theme.colors.gray[400], marginBottom: theme.spacing.md }}>
                Entre em contacto connosco para qualquer dúvida
              </p>
              <a 
                href="https://wa.me/258842566731" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: theme.spacing.sm,
                  backgroundColor: "#25D366",
                  color: theme.colors.white,
                  padding: `${theme.spacing.sm} ${theme.spacing.md}`,
                  borderRadius: theme.borderRadius.md,
                  textDecoration: "none",
                  fontWeight: theme.typography.fontWeight.medium,
                  transition: "all 0.3s ease",
                  fontSize: theme.typography.fontSize.sm,
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow = "0 4px 12px rgba(37, 211, 102, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "none";
                }}
              >
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
                WhatsApp
              </a>
            </div>
          </div>
          <div style={{
            borderTop: `1px solid ${theme.colors.gray[700]}`,
            paddingTop: theme.spacing.lg,
            color: theme.colors.gray[400],
          }}>
            © 2025 <a 
              href="https://ivaneusebio.vercel.app" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: theme.colors.primary, textDecoration: "none", fontWeight: theme.typography.fontWeight.bold }}
            >
              UnityMoz
            </a>. Todos os direitos reservados.
          </div>
        </div>
      </footer>

      {/* Animations */}
      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateX(-50%) translateY(0);
            }
            40% {
              transform: translateX(-50%) translateY(-10px);
            }
            60% {
              transform: translateX(-50%) translateY(-5px);
            }
          }
          
          @keyframes scroll {
            0% {
              transform: translateY(0);
              opacity: 1;
            }
            100% {
              transform: translateY(20px);
              opacity: 0;
            }
          }
        `}
      </style>
    </div>
  );
}

export default Home;
